import { FC, useState } from 'react'
import { find } from 'lodash'

import { Tabs as MerinioTabs } from 'ui'

import { t } from 'translations'

type Props = {
  defaultTab?: string
  module: string
  tabs: { name: string; component: JSX.Element }[]
}

const Tabs: FC<Props> = ({ defaultTab, module, tabs }): JSX.Element => {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0].name)

  const activeComponent = find(tabs, { name: activeTab })
  const componentToDisplay = activeComponent?.component || null

  return (
    <>
      <MerinioTabs>
        {tabs.map(({ name }) => {
          return (
            <MerinioTabs.Item key={name} tabKey={name} active={activeTab === name} onSelect={setActiveTab}>
              {t(`${module}.${name.toUpperCase()}`)}
            </MerinioTabs.Item>
          )
        })}
      </MerinioTabs>
      {componentToDisplay}
    </>
  )
}

export { Tabs }
